import { createSelector } from '@reduxjs/toolkit';

import { maskEmail } from '../../helpers/email';
import { RootState } from '../types';

export const userDataSelector = (state: RootState) => state.userData;
export const maskedEmailSelector = createSelector(userDataSelector, ({ email }) =>
  maskEmail(email),
);
